import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { MasterPlansRepository } from "../../repositories";
import { Observable } from "rxjs";
import { CommitPlanRequest } from "../../domain/requests/master-plan.ts/commit-plan.request";

@Injectable({ providedIn: 'root' })
export class CommitPlanUsecase implements UseCase<CommitPlanRequest, boolean> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: CommitPlanRequest): Observable<boolean> {
    return this.masterPlanRepository.commitPlan(params);
  }
}
